import {i18n} from '@yourcoach/i18n';

import type {ProgramPaymentType} from './types';

interface ProgramPaymentTypeEnum {
  MONTHLY: ProgramPaymentType;
  ONE_TIME: ProgramPaymentType;
}

export const ProgramPaymentTypeEnum: ProgramPaymentTypeEnum = {
  MONTHLY: {
    id: 'monthly',
  },
  ONE_TIME: {
    id: 'one_time',
  },
};

Object.keys(ProgramPaymentTypeEnum).forEach(key => {
  const type: ProgramPaymentType = ProgramPaymentTypeEnum[key];

  type.toString = () =>
    /**
     * @i18n_parser
     * t('shared:program.payment_type.monthly')
     * t('shared:program.payment_type.one_time')
     */
    i18n.t(`shared:program.payment_type.${type.id}`);
});
